import { createReducer, on } from '@ngrx/store';
import { Currency } from '@rx-applications/shared/data-access';
import * as currencyActions from './currency.actions';

export interface CurrencyState {
  currencies: Currency[];
  loading: boolean;
}

export const initialCurrencyState: CurrencyState = {
  currencies: [],
  loading: false,
};

export const currencyReducer = createReducer(
  initialCurrencyState,

  on(currencyActions.loadCurrencyList, (state) => ({
    ...state,
    loading: true,
  })),

  on(currencyActions.loadCurrencyListSucceed, (state, { payload: currencies }) => {
    return {
      ...state,
      currencies,
      loading: false,
    };
  }),

  on(currencyActions.loadCurrencyListFailed, (state) => ({
    ...state,
    loading: false,
  }))
);
